// predefined imports
import PropTypes from 'prop-types';
import {
  Box, Container
} from '@mui/material';

import { useStyles } from './style';

export const StartPagesContainer = ({ children, addBgBlur = false }) => {
  const classes = useStyles();

  return (
    <Box className={classes.startPageContainer}>
      <Container maxWidth="md" className={classes.fullPageHeight}>
        {children}
      </Container>
      <Box className={classes.buldingContainer}>
        <Box className={addBgBlur ? classes.imgBlur : ''} component="img" src="./assets/images/bluetimecity.svg" alt="City" />
      </Box>
    </Box>
  );
};

StartPagesContainer.propTypes = {
  children: PropTypes.element,
  addBgBlur: PropTypes.bool
};

StartPagesContainer.defaultProps = {
  children: null,
  addBgBlur: false
};
